import { render, staticRenderFns } from "./RegosParts.vue?vue&type=template&id=d8ebd520&scoped=true&"
import script from "./RegosParts.vue?vue&type=script&lang=js&"
export * from "./RegosParts.vue?vue&type=script&lang=js&"
import style0 from "./RegosParts.vue?vue&type=style&index=0&id=d8ebd520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ebd520",
  null
  
)

export default component.exports